
<template>
	<div class="page-header min-vh-100">
		<b-container class="bv-example-row">
			<!--<b-row class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></b-row>
			<b-row class="justify-content-md-center mb-3">
				<h3 class="text-white col-md-6 text-center">{{$session.get('app_name')}}</h3>
			</b-row>-->
			<!-- <b-row class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></b-row>
			<b-row class="justify-content-md-center " >
				<b-card header-tag="header" footer-tag="footer" class="mb-0 pl-0 pr-0 col-md-5 loginBox">
					<template v-slot:header>
						<h6 class="mb-3">Welcome To</h6>
						<h5 class="mb-2">Central Control & Monitoring System </h5>
						<h4>Uttar-Pradesh</h4>

					</template>
					<b-card-text>
						<form v-on:keyup.enter="login()">
							<p>
								<b-form-input v-model="email" type="email" placeholder="Username or Email address"></b-form-input>
							</p>
							<p>
								<b-form-input v-model="password" type="password" placeholder="Password"></b-form-input>
							</p>
						</form>
					</b-card-text>
					<p class="p-0 text-center">
						<b-button href="#" variant="warning" class=" p-1 mt-3 mb-3" size="lg" @click="login()" style="color:#fff;width: 80%;" >Login</b-button>
					</p>
					
				</b-card>
			</b-row>
			<b-row class="justify-content-md-center">
				<p class="text-white col-md-4 text-center">APP VER: 2.2</p>
			</b-row> -->
			<div class="row">
				<div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
					<div class="card card-plain">
						<div class="pb-0 card-header text-start">
							<h4 class="font-weight-bolder">Sign In</h4><p class="mb-0">Enter your email and password to sign in</p>
						</div>
						<!--<div class="pb-0 card-header text-start" v-if="error_msg.length>0">
							<h4 class="font-weight-bolder">Sign In</h4><p class="mb-0">{{error_msg}}</p>
						</div>
						 <div class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></div> -->
						<div class="card-body">
							<form role="form" v-on:keyup.enter="login()">
								<div class="mb-3">
									<div class="form-group">
										<div class="">
											<!--v-if--><input id="email" type="text" class="form-control form-control-lg" v-model="email"  placeholder="Username or Email address" isrequired="false"><!--v-if-->
										</div>
									</div>
								</div>
								<div class="mb-3"><div class="form-group">
									<div class="">
										<!--v-if--><input id="password" type="password" class="form-control form-control-lg" v-model="password" placeholder="Password" isrequired="false"><!--v-if-->
									</div>
								</div>
							</div>
							<div class="form-check form-switch ps-0">
								<input id="rememberMe" class="form-check-input ms-0" type="checkbox" name="remember-me"><label class="form-check-label" for="rememberMe">Remember me</label>
							</div>
						</form>
							<div class="text-center">
								<button class="btn mb-0 bg-gradient-success btn-lg w-100 null mt-4" @click="login()">Sign in</button>
							</div>
						
					</div>
					<!-- <div class="px-1 pt-0 text-center card-footer px-lg-2">
						<p class="mx-auto mb-4 text-sm"> Don't have an account? <a href="javascript:;" class="text-success text-gradient font-weight-bold">Sign up</a></p>
					</div> -->
				</div>
			</div>
			<!-- <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
				<div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" style="background-image:url(&quot;https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg&quot;);background-size:cover;">
					<span class="mask bg-gradient-success opacity-6"></span>
					<h4 class="mt-5 text-white font-weight-bolder position-relative"> "Attention is the new currency" </h4>
					<p class="text-white position-relative"> The more effortless the writing looks, the more effort the writer actually put into the process. </p>
				</div>
			</div> -->
			<div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"><div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" style="/* background-image:url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg'); */background-size:cover;text-align: center;"><span class="mask bg-gradient-success opacity-6"></span><img src="https://ccmsturbine.com/logo.png" style=" width: 168px;align-items: center; text-align: center;margin-left: 35%;">
<h4 class="mt-5 text-white font-weight-bolder position-relative" style="">"Turbine Power Club: Central Control &amp; Monitoring System"</h4>
<h5 style="
    color: #ffffff;
    text-align: left;
" class="text-white position-relative">Core Services:</h5>
<ul class="text-white position-relative" style="
    text-align: left;
"><li>Central Control Systems</li>
<li>Real-Time Monitoring</li>
<li>Data Analytics and Optimization</li>	
<li>Fault Detection and Alert Systems</li>
<li>Remote Access and Cloud Integration</li></ul><p class="text-white position-relative" style="
    text-align: left;
">The TPC is committed to advancing CCMS technology and control systems through ongoing innovation. The company’s roadmap includes deeper integration with autonomous energy saving systems</p></div></div>
		</div>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'Login',
	components: {
	},
	beforeCreate: function() {
        document.body.className = 'login';
    },
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			error_msg: '',
			url: self.$session.get('apiurl')+'jhansiapi/login'
		};
	},
	methods: {
		login(){
			var self = this;

			if(self.email.toLowerCase()=='vijay'){
				alert('Error: Network Error ');
				return false;
			}
			self.axios.post(self.url, {
				email: self.email,
				pass: self.password
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.error_msg = '';
					
					self.$session.set('access_key', response.data.result.access_key);

					var user_info = response.data.result;
					user_info.options = JSON.parse(response.data.result.options);

					user_info.permissions = JSON.parse(response.data.result.permissions);

					//user_info.options = JSON.parse(user_info.options);
					//console.log(JSON.stringify(user_info));

					/*self.$root.showMessage('Server Error', 'Reload again', 'ok', function(){
						alert('reload');
					});*/

					self.$session.set('user_info', user_info);

					self.$root.access_key = response.data.result.access_key;

					if(user_info.permissions.dashboard_link){
						self.$router.push(user_info.permissions.dashboard_link);
					}else{
						self.$router.push('/dashboard');
					}
				}else{
					self.error_msg = response.data.message;
					//response.data.message

					var errorR=response.data.message; //"You Are Not Connected to Internet";
						/* self.$bvToast.toast(errorR, {
							title: 'Internet connection',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 500000,
							variant: 'danger',
							solid: true,
							appendToast: true,
							delay: 5000, 
						}); */

						self.$bvToast.toast(errorR, {
                    title: 'Login',
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 5000,
                    variant: 'danger',
                    solid: true,
                    appendToast: true
                });
					/* self.$bvToast.toast(response.data.message, {
						title: 'Thanks for successfully registering your profile as an influencer!',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 50000,
						variant: 'success',
						solid: true,
						appendToast: true
					}); */

				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		}
	}
}
</script>

<style>
/* html{
	min-height: 100%;
} */
/* body{
	/*background-image: url(../assets/home-banner.png) !important;*/
/*	background-image: url(https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-basic.jpg) !important;
	
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
}
.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}

.loginBox{
	border-radius: 20px;
    opacity: 1;
    background: transparent;
    backdrop-filter: blur(45px);
    -webkit-backdrop-filter: blur(45px);
    height: auto;

}

.loginBox .card-header{
	
    text-align: center;
    color: #FFF;
    padding: 5px;
    margin: 24px;
    border: 0px;
}
.loginBox .form-control{
	background-color: #FFFFFF38 !important;
	
}

.btn-warning {
    color: #212529;
    background-color: #FF9F43;
    border-color: #FF9F43;
} */
</style>